<template>
  <div class="main">
    <landingBanner
      landingUrl="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/business/banner.jpg"
    ></landingBanner>
    <div class="content">
      <count2></count2>
      <div style="width:100%;height:20px;"></div>
      <van-image
        src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/business/part1.jpg"
      >
        <template v-slot:loading>
          <van-loading size="20" color="#fff" />
        </template>
      </van-image>
    </div>
    <van-image src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/business/part2.jpg">
      <template v-slot:loading>
        <van-loading size="20" color="#fff" />
      </template>
    </van-image>
    <div class="content">
      <van-image
        src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/business/part3.jpg"
      >
        <template v-slot:loading>
          <van-loading size="20" color="#fff" />
        </template>
      </van-image>
      <div class="button">
        <a href="javascript:void(0)" onclick="ydtopenchat();return false;">
        <van-button color="#955225" style="width:100%">了解更多帮扶</van-button></a>
      </div>
      <div style="width:100%;height:30px;"></div>
      <indexTitle title1="成功创业案例" title2="2020年开家这样的店!可以盛得下财富自由阳光喜悦" color="#955225"></indexTitle>
      <van-image
        src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/business/part4.jpg"
      >
        <template v-slot:loading>
          <van-loading size="20" color="#fff" />
        </template>
      </van-image>
      <count2></count2>
    </div>
    <div class="h25px" style="width:100%;height:25px;"></div>
    <foot></foot>
  </div>
</template>

<script>
export default {
  components: {
    landingBanner: () => import("../../../components/common/landing-banner"),
    foot: () => import("@/components/foot/foot"),
    find2: () => import("@/components/common/find2"),
    indexTitle: () => import("@/components/common/indexTitle"),
    count2: () => import("@/components/form/count2")
  }
};
</script>

<style lang="less" scoped>
/deep/ .van-swipe__indicators{
  bottom: 15px;
    left: 10%;
}
.content {
  width: 100%;
  padding: 10px;
  background: #fff;
}
</style>